import { jsx as _jsx } from "react/jsx-runtime";
import { Gear } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { Popover } from "@air/primitive-popover";
import { memo } from "react";
import { CONFIG_VIEWS_VISIBILITY } from "~/constants/testIDs";
export const ViewVisibilityToggleMenu = /*#__PURE__*/ memo((param)=>{
    let { children } = param;
    return /*#__PURE__*/ _jsx(Popover, {
        side: "bottom",
        align: "end",
        trigger: /*#__PURE__*/ _jsx(IconButton, {
            appearance: "ghost",
            color: "grey",
            size: "medium",
            label: "Visibility Toggles",
            "data-testid": CONFIG_VIEWS_VISIBILITY,
            icon: Gear
        }),
        children: children
    });
});
ViewVisibilityToggleMenu.displayName = "ViewVisibilityToggleMenu";
